@if (aggregations() && aggregations().length > 0) {
  <span class="aggregation-container">
    <mat-form-field>
      <mat-select
        [value]="aggregations()[0]"
        [compareWith]="compareAggregations"
        [disabled]="aggregations().length == 1"
        panelClass="aggregation-dropdown-panel">
        @for (aggregation of aggregations(); track aggregation.type) {
          <mat-option [value]="aggregation">
            {{ aggregation | aggregationLabel }} =
            {{ aggregation.value | number }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </span>
}
